// アニメーション関数を定義
export function fadeAnime() {
    // 汎用的なアニメーションクラスとその対応する追加クラスをまとめる
    const animations = [
        { triggerClass: ".fadeInTrigger", addClass: "-fadeIn" },
        { triggerClass: ".fadeUpTrigger", addClass: "-fadeUp" },
        { triggerClass: ".fadeDownTrigger", addClass: "-fadeDown" },
        { triggerClass: ".fadeLeftTrigger", addClass: "-fadeLeft" },
        { triggerClass: ".fadeRightTrigger", addClass: "-fadeRight" },
    ];

    animations.forEach(({ triggerClass, addClass }) => {
        document.querySelectorAll(triggerClass).forEach(function (elem) {
            const elemPos = elem.getBoundingClientRect().top + window.pageYOffset - 50;
            const scroll = window.pageYOffset;
            const windowHeight = window.innerHeight;

            if (scroll >= elemPos - windowHeight) {
                elem.classList.add(addClass);
            }
        });
    });
}

// スクロールイベントでアニメーション関数を呼び出す
export function setupScrollAnimation() {
    window.addEventListener("scroll", fadeAnime);
}

// 初期化用の関数を実行
setupScrollAnimation();
